var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPyronometerBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7793 14.2981C17.6731 14.6745 19.0132 14.6515 18.8378 12.8249C18.8378 8.04314 14.9614 4.16675 10.1797 4.16675C5.39788 4.16675 1.52148 8.04314 1.52148 12.8249C1.52148 15.02 2.78696 14.8727 4.76374 14.3431C5.45943 14.6027 6.45472 14.4897 7.62894 14.3563C8.42232 14.2661 9.29738 14.1667 10.2169 14.1667C11.1364 14.1667 12.0115 14.2661 12.8048 14.3563C14.042 14.4968 15.0805 14.6148 15.7793 14.2981ZM15.7793 14.2981C16.3878 14.0224 16.7386 13.4171 16.7386 12.2102C16.7386 8.7284 13.8187 5.90584 10.2169 5.90584C6.61503 5.90584 3.69515 8.7284 3.69515 12.2102C3.69515 13.4876 4.08819 14.0911 4.76374 14.3431C4.9661 14.2889 5.17591 14.2307 5.39258 14.1706C6.76378 13.7901 8.4097 13.3334 10.1797 13.3334C11.5525 13.3334 13.0453 13.6792 14.3994 13.9928C14.8808 14.1043 15.3446 14.2117 15.7793 14.2981Z",
    fill: "#1E2447"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 15.0364,
    width: 1.81818,
    height: 20,
    rx: 0.3,
    transform: "rotate(-90 0 15.0364)",
    fill: "#1E2447"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyronometerBlue);
export default __webpack_public_path__ + "static/media/Pyronometer_Blue.f9f19c3b.svg";
export { ForwardRef as ReactComponent };